export default __webpack_public_path__ + "static/media/victim-support.7ff85c30.jpeg";